import React, { useState, useRef } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "./Home.css";
import "../utils/style.css";
import { Container, Typography } from "@mui/material";
import NavMenu from "./Menu";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// FilePond styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";
import particlesBg from "particles-bg";   

// FilePond plugins
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import FilePondPluginFileMetadata from "filepond-plugin-file-metadata";
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

registerPlugin(
  FilePondPluginFileEncode,
  FilePondPluginFilePoster,
  FilePondPluginFileMetadata,
  FilePondPluginFileRename,
  FilePondPluginImageTransform,
  FilePondPluginImageResize,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageValidateSize
);

const Upload = () => {
  const pondRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [petname, setPetname] = useState("");

  const handleInit = () => console.log("✅ FilePond initialized:", pondRef.current);

  const handleBeforeUpload = () => {
    if (!petname.trim()) {
      toast.error("🐾 Please enter a pet name before uploading!", {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  return (
    <>
    <particlesBg type="circle" margin="5px" bg={true} />
      <NavMenu />

      <ToastContainer />

      <Container
        maxWidth="sm"
        sx={{
          mt: 10,
          mb: 6,
          p: 4,
          borderRadius: "20px",
          backdropFilter: "blur(20px)",
          background: "rgba(0, 0, 0, 0.55)",
          boxShadow: "0 0 40px rgba(0, 0, 0, 0.6)",
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            fontWeight: "bold",
            color: "#fff",
            textShadow: "0 2px 10px rgba(0,0,0,0.9)",
            letterSpacing: "0.5px",
          }}
        >
          🐶 Upload Pet Photos
        </Typography>

        <FilePond
          ref={pondRef}
          files={files}
          name="files"
          allowFileEncode
          allowAutoUpload={false}
          allowMultiple
          allowImagePreview
          imagePreviewHeight={180}
          labelIdle='📁 <span class="filepond--label-action">Browse</span> or drop files here'
          credits={false}
          maxFiles={10}
          acceptedFileTypes={["image/*"]}
          server={{
            process: (fieldName, file, metadata, load, error, progress, abort) => {
              if (!handleBeforeUpload()) {
                error("Pet name is required");
                return abort();
              }

              const formData = new FormData();
              formData.append("files", file, file.name);
              formData.append("petname", petname.trim());

              const request = new XMLHttpRequest();
              request.open("POST", "/api/upload/local");

              request.upload.onprogress = (e) => {
                progress(e.lengthComputable, e.loaded, e.total);
              };

              request.onload = function () {
                if (request.status >= 200 && request.status < 300) {
                  toast.success("✅ Upload successful!", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                  });
                  load(request.responseText);
                } else {
                  toast.error("❌ Upload failed", { theme: "colored" });
                  error("Upload failed");
                }
              };

              request.onerror = () => {
                toast.error("🚫 Network error", { theme: "colored" });
                error("Network error");
              };

              request.send(formData);

              return {
                abort: () => {
                  request.abort();
                  abort();
                },
              };
            },
          }}
          oninit={handleInit}
          onupdatefiles={(fileItems) =>
            setFiles(fileItems.map((fileItem) => fileItem.file))
          }
        />

        <div
          style={{
            marginTop: "25px",
            position: "relative",
            zIndex: 5,
          }}
        >
          <input
            id="petname"
            type="text"
            value={petname}
            placeholder="Enter Pet Name"
            onChange={(e) => setPetname(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid rgba(255,255,255,0.3)",
              backgroundColor: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontSize: "1rem",
              outline: "none",
              transition: "all 0.3s ease",
            }}
            onFocus={(e) =>
              (e.target.style.backgroundColor = "rgba(255,255,255,0.25)")
            }
            onBlur={(e) =>
              (e.target.style.backgroundColor = "rgba(255,255,255,0.15)")
            }
          />
        </div>

        <Typography
          variant="body2"
          sx={{
            mt: 5,
            color: "rgba(255,255,255,0.6)",
            fontSize: "0.85rem",
          }}
        >
          © {new Date().getFullYear()} Knight’s Kennel | Upload center powered by FilePond
        </Typography>
      </Container>

      <style>{`
        .filepond--root {
          background: rgba(255, 255, 255, 0.07);
          border: 2px dashed rgba(255,255,255,0.25);
          border-radius: 16px;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }
        .filepond--root:hover {
          border-color: #00e5ff;
          box-shadow: 0 0 25px rgba(0,229,255,0.4);
        }
        .filepond--drop-label {
          color: #fff;
          font-weight: bold;
          text-shadow: 0 0 5px rgba(0,0,0,0.8);
        }
        .filepond--file {
          background-color: rgba(0,0,0,0.4);
          border-radius: 10px;
          color: #fff;
          backdrop-filter: blur(8px);
        }
        .filepond--item-panel {
          background-color: rgba(255,255,255,0.15);
        }
        .filepond--panel-root {
          background-color: transparent !important;
        }
        .filepond--file-action-button {
          color: #fff !important;
        }
      `}</style>
    </>
  );
};

export default Upload;
